import CheckboxFieldGroup from './CheckboxFieldGroup.component';

export default CheckboxFieldGroup;